export const ENTER_KEY = 13;
export const ESCAPE_KEY = 27;
export const ARROW_DOWN_KEY = 40;
export const ARROW_UP_KEY = 38;
export const ARROW_LEFT_KEY = 37;
export const ARROW_RIGHT_KEY = 39;
export const SPECIAL_KEYS = [
    ENTER_KEY,
    ESCAPE_KEY,
    ARROW_DOWN_KEY,
    ARROW_UP_KEY,
    ARROW_LEFT_KEY,
    ARROW_RIGHT_KEY,
];
//# sourceMappingURL=constants.js.map